module.exports = __webpack_public_path__ + "img/av281.f89087fe.png";